import { render } from "./CookiesDonutCard.vue?vue&type=template&id=003c97b1&scoped=true&ts=true"
import script from "./CookiesDonutCard.vue?vue&type=script&lang=ts"
export * from "./CookiesDonutCard.vue?vue&type=script&lang=ts"

import "./CookiesDonutCard.vue?vue&type=style&index=0&id=003c97b1&scoped=true&lang=css"
import "./CookiesDonutCard.vue?vue&type=style&index=1&id=003c97b1&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003c97b1"]])

export default __exports__